// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sg_e","col":"styles_col__1_JO4"};